import {
  DetailsWoForBulkDownloadResponse,
  ImageTypeDownloadable,
} from "../Utilities";
import BulkDownloadImagesGroup from "./BulkDownloadImagesGroup";

interface Props {
  detailsWo: DetailsWoForBulkDownloadResponse | null;
  cropGroupSelected: string | null;
  exsistDownloadableByType: ImageTypeDownloadable;
}

export default function BulkDownloadImages(props: Props) {
  return (
    <>
      {props.detailsWo.imageLinkedToWo ||
      props.detailsWo.episodeLinkedImages ? (
        <>
          {props.detailsWo.imageLinkedToWo &&
            Object.keys(props.detailsWo.imageLinkedToWo).map(
              (type) =>
                props.exsistDownloadableByType[type] && (
                  <BulkDownloadImagesGroup
                    label={type}
                    imagesArray={props.detailsWo.imageLinkedToWo[type]}
                    cropGroupSelected={props.cropGroupSelected}
                  ></BulkDownloadImagesGroup>
                )
            )}
          {props.detailsWo.episodeLinkedImages &&
            Object.keys(props.detailsWo.episodeLinkedImages).map(
              (episodeName) =>
                props.detailsWo.episodeLinkedImages[episodeName] ? (
                  Object.keys(
                    props.detailsWo.episodeLinkedImages[episodeName]
                  ).map(
                    (type) =>
                      props.exsistDownloadableByType[
                        episodeName + "-" + type
                      ] && (
                        <BulkDownloadImagesGroup
                          label={episodeName + "_" + type}
                          imagesArray={
                            props.detailsWo.episodeLinkedImages[episodeName][
                              type
                            ]
                          }
                          cropGroupSelected={props.cropGroupSelected}
                        ></BulkDownloadImagesGroup>
                      )
                  )
                ) : (
                  <></>
                )
            )}
        </>
      ) : (
        <></>
      )}
    </>
  );
}
